// extracted by mini-css-extract-plugin
export var activeLink = "Pagination-module--activeLink--ede8a";
export var arrowButton = "Pagination-module--arrowButton--d5919";
export var digit = "Pagination-module--digit--0d2e2";
export var disabled = "Pagination-module--disabled--50e35";
export var pagination = "Pagination-module--pagination--56413";
export var paginationDigitList = "Pagination-module--paginationDigitList--46e9c";